module.exports = __webpack_public_path__ + "img/sj04.8b5c1b78.png";